import { useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { useGetTasksQuery } from "../services/tasksApi";
import { useChannelQuery } from "../services/websocketApi.ts";

export default function TasksDropdown({ selectedTask, onTaskSelect, className, TasksProject, editedTask, enabled = true }) {
  const shouldSkip = !enabled || !TasksProject;
  const { data: tasks = [], isLoading, isFetching, isError, refetch } = useGetTasksQuery(
    { type: 'task', project: TasksProject },
    { skip: shouldSkip }
  );
    let chosenTask = {name: "brak", id:"brak"};
    if(selectedTask){
     chosenTask = tasks.filter((task => task.id === selectedTask))[0]
    }
  const { data: projectEvents } = useChannelQuery('projects');

  useEffect(() => {
    if (shouldSkip) return;
    if (projectEvents?.messages.length && tasks) {
      refetch();
    }
  }, [tasks, refetch, projectEvents, shouldSkip]);
   


  return (
      <>
        <label htmlFor="tasksDropdown">Zadanie powiązane</label>
        <Dropdown
          value={chosenTask}
          onChange={(e) => onTaskSelect(e.value)}
          options={[ {name: "brak", id:"brak"},...tasks.filter((task)=> task.id!==editedTask.id)]}
          optionLabel="name"
          placeholder="Wybierz zadanie..."
          className={className}
          filter
          loading={isLoading || isFetching}
          emptyMessage={isError ? "Błąd ładowania." : "Brak zadań"}
          defaultValue="brak"
          inputId="tasksDropdown"
        />
      </>
  );
}